import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const AppointmentTypeCall: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon fillRule="evenodd" stroke="none" {...props}>
      <g clipPath="url(#a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.89 4.406h-.843V3H16.64v1.406H7.359V3H5.953v1.406H5.11c-1.164 0-2.11.947-2.11 2.11V18.89C3 20.054 3.946 21 5.11 21h13.78c1.164 0 2.11-.946 2.11-2.11V6.517c0-1.163-.946-2.11-2.11-2.11Zm.704 14.485a.704.704 0 0 1-.703.703H5.109a.704.704 0 0 1-.703-.703V9.609h15.188v9.282ZM4.406 8.203h15.188V6.516a.704.704 0 0 0-.703-.704h-.844V7.22H16.64V5.812H7.359V7.22H5.953V5.812H5.11a.704.704 0 0 0-.703.704v1.687Z"
          fill="currentColor"
        />
        <g clipPath="url(#b)">
          <path
            d="M9.982 14.171a5.68 5.68 0 0 0 2.472 2.471l.825-.824a.373.373 0 0 1 .382-.09 4.3 4.3 0 0 0 1.339.213c.206 0 .375.169.375.375v1.309A.376.376 0 0 1 15 18a6.374 6.374 0 0 1-6.375-6.375c0-.206.169-.375.375-.375h1.313c.206 0 .374.169.374.375 0 .469.075.919.214 1.339a.376.376 0 0 1-.094.382l-.825.825Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
        <clipPath id="b">
          <path transform="translate(7.5 10.125)" d="M0 0h9v9H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
